import React, { FC } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { Separator, Title } from 'src/front/components/FormStyles';
import HistoryFormIntrabank from './componenets/HistoryFormIntrabank';

const ViewHistorIntrabank: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Title>
        <Trans i18nKey={t('callCenter_internetBanking_intrabankMoneyTransfersHistory_title')} />
      </Title>
      <Separator />
      <HistoryFormIntrabank />
    </>
  );
};
export default ViewHistorIntrabank;
